import axios from "axios";

import { listProductCategory } from "./mock/mockData";

const actions = {
  async listPersonalLine(context, payload) {
    try {
      const response = await this.$api.call(
        "personal_lines.listPersonalLine",
        payload,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationPersonalLines", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationPersonalLines", responseData);
      }

      context.commit("mutationPersonalLinesMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationPersonalLines", []);
      context.commit("mutationPersonalLinesMeta", {});

      throw error;
    }
  },

  async listQuickView(context, payload) {
    try {
      const response = await this.$api.call(
        "personal_lines.listQuickView",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationQuickViews", responseData);

      return response;
    } catch (error) {
      context.commit("mutationQuickViews", []);
      throw error;
    }
  },

  async listProductCategory(context) {
    try {
      // TODO: hide for temporary, needs to hardcode for personal lines category
      // const response = await this.$api.call('personal_lines.listProductCategory', payload);
      const response = listProductCategory;
      context.commit("mutationListProductCategory", response.data);
      return response;
    } catch (error) {
      context.commit("mutationListProductCategory", {});
      throw error;
    }
  },

  async downloadAllPersonalLine(_context, payload) {
    try {
      const response = await this.$api.call(
        "personal_lines.downloadAllPersonalLine",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPresignPolicy(_context, payload) {
    try {
      const response = await this.$api.call(
        "personal_lines.getPresignPolicy",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getPresign(_context, payload) {
    try {
      const response = await this.$api.call(
        "personal_lines.getPresign",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      const response = await axios.put(url, buffer, {
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          context.commit(
            "mutationUploadProgress",
            parseInt(Math.round(progress), 10),
          );
        },
      });
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    } finally {
      context.commit("mutationUploadProgress", 0); // reset uploadProgress to 0 (init state)
    }
  },
  async listInsuranceBranch(context, payload) {
    try {
      const response = await this.$api.call(
        "personal_lines.listInsuranceBranch",
        payload,
      );
      context.commit("mutationListInsuranceBranch", response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
